import { defineContext } from '@nzyme/vue-utils/context.js';
import type { ChatViewModel } from '@sigma/client/chat/ChatViewModel.js';

export interface ChatContext {
    chat: ChatViewModel;
}

export const ChatContext = defineContext<ChatContext>('ChatContext');
